/* tslint:disable */
/* eslint-disable */
/**
 * Commerce API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SearchRequestModel
 */
export interface SearchRequestModel {
    /**
     * 
     * @type {number}
     * @memberof SearchRequestModel
     */
    from?: number;
    /**
     * 
     * @type {number}
     * @memberof SearchRequestModel
     */
    size?: number;
    /**
     * 
     * @type {string}
     * @memberof SearchRequestModel
     */
    searchTerms?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchRequestModel
     */
    sorting?: string;
    /**
     * 
     * @type {number}
     * @memberof SearchRequestModel
     */
    priceRangeInterval?: number;
    /**
     * 
     * @type {{ [key: string]: Array<string> | undefined | null; }}
     * @memberof SearchRequestModel
     */
    facets?: { [key: string]: Array<string> | undefined | null; };
    /**
     * 
     * @type {Array<Array<string>>}
     * @memberof SearchRequestModel
     */
    tags?: Array<Array<string>>;
}

/**
 * Check if a given object implements the SearchRequestModel interface.
 */
export function instanceOfSearchRequestModel(value: object): boolean {
    return true;
}

export function SearchRequestModelFromJSON(json: any): SearchRequestModel {
    return SearchRequestModelFromJSONTyped(json, false);
}

export function SearchRequestModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchRequestModel {
    if (json == null) {
        return json;
    }
    return {
        
        'from': json['from'] == null ? undefined : json['from'],
        'size': json['size'] == null ? undefined : json['size'],
        'searchTerms': json['searchTerms'] == null ? undefined : json['searchTerms'],
        'sorting': json['sorting'] == null ? undefined : json['sorting'],
        'priceRangeInterval': json['priceRangeInterval'] == null ? undefined : json['priceRangeInterval'],
        'facets': json['facets'] == null ? undefined : json['facets'],
        'tags': json['tags'] == null ? undefined : json['tags'],
    };
}

export function SearchRequestModelToJSON(value?: SearchRequestModel | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'from': value['from'],
        'size': value['size'],
        'searchTerms': value['searchTerms'],
        'sorting': value['sorting'],
        'priceRangeInterval': value['priceRangeInterval'],
        'facets': value['facets'],
        'tags': value['tags'],
    };
}

